import { Component } from '@angular/core';
import { MixpanelService } from '../../../services/mixpanel.service';
import { environment } from '../../../../environments/environment';
import { MetaService } from '../../../services/meta.service';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent {
  constructor(private mix: MixpanelService, private metaService: MetaService) {
    this.mix.trackPageVisit();
  }
  ngOnInit(): void {
    this.updateMetaTags()
  }
  updateMetaTags() {
    // const title = 'Privacy Policy: Our Commitment to Your Privacy | Mentoga';
    // const description = "Read Mentoga's Privacy Policy to understand how we protect your data and privacy. Learn about our data handling practices and your rights as a user. Ensuring your privacy is our priority.";
    const title = 'Privacy Policy | Mentoga';
    const description = "Discover Mentoga's privacy policy and see how we handle your sensitive information. Learn how your personal data is protected when using our platform.";
    const ogUrl = window.location.href;
    this.metaService.updateMetaTags(title, description, null, title, description, ogUrl);
  }
}
